import {ContentBlocks, CustomPageMetadata} from '@aboutyou/logic-components';
import React from 'react';

export const CustomPage = () => {
  return (
    <>
      <CustomPageMetadata />
      <ContentBlocks />
    </>
  );
};
